import { render, staticRenderFns } from "./auditAuthOwnerUndoList.vue?vue&type=template&id=be494432&scoped=true"
import script from "./auditAuthOwnerUndoList.vue?vue&type=script&lang=js"
export * from "./auditAuthOwnerUndoList.vue?vue&type=script&lang=js"
import style0 from "./auditAuthOwnerUndoList.vue?vue&type=style&index=0&id=be494432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be494432",
  null
  
)

export default component.exports